import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  Tab,
  Tabs,
  Typography,
  IconButton,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import DatatableComponent from "helpers/DatatableComponent";
import { connect } from "react-redux";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import PermissionDetails from "./PermissionDetails";
import TabPanel from "helpers/TabPanel";
import { a11yProps } from "components/Meetings/Meeting";
import LeaveCalendar from "components/UI/LeaveCalendar";
import StatusLayout from "components/Status";
import FormDialog from "helpers/FormDialog";
import moment from "moment";

const AnnualLeave = (props) => {
  const { DownloadExcelFile, SetSelectedMenu, FetchDetails } = props;
  const date = new Date();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState();
  const [year, setYear] = useState(date.getFullYear());
  const [formOpen, setFormOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [formData, setFormData] = useState({
    remainingDays: 0,
    carryoverDays: 0,
  });
  const [requestId, setRequestId] = useState("");
  const [refreshKey, setRefreshKey] = useState(0); // Add a refresh key state
  const tableRef = useRef(null); // Reference to the datatable component
  const [leaveType, setLeaveType] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const fields = [
    {
      name: "remainingDays",
      label: "Days Available (This Year)",
      type: "number",
      value: formData.remainingDays,
      setValue: (value) =>
        setFormData((prev) => ({ ...prev, remainingDays: value })),
      required: true,
    },
    {
      name: "carryoverDays",
      label: "Carried Over Days",
      type: "number",
      value: formData.carryoverDays,
      setValue: (value) =>
        setFormData((prev) => ({ ...prev, carryoverDays: value })),
      required: true,
    },
  ];

  // Fetch leave type on component mount
  useEffect(() => {
    const fetchLeaveType = async () => {
      try {
        const response = await FetchDetails("/api/request/categories/");
        if (response.status) {
          const annualLeaveType = response.data.categories.find(
            (cat) => cat.type === "annual"
          );
          if (annualLeaveType) {
            setLeaveType(annualLeaveType);
          }
        }
      } catch (error) {}
    };

    fetchLeaveType();
    setCurrentMonth(new Date().getMonth());
  }, []);

  // Calculate available days based on the schedule logic
  const calculateAvailableDays = (resource) => {
    if (!resource || !resource.Requests || !leaveType) return 0;

    const annualLeave = resource.Requests.find(
      (req) =>
        req.year === year &&
        req.resourceId === resource.id &&
        req.categoryId === leaveType.id
    );

    return annualLeave ? annualLeave.remainingDays : 0;
  };

  const columns = [
    {
      name: "names",
      label: "Names",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "StaffPosition.name",
      label: "Position",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "entryDate",
      label: "Entry Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => moment(v).format("YYYY-MM-DD"),
      },
    },
    {
      name: "leaveDays",
      label: "Days Available (This Year)",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v, tableMeta) => {
          const resourceIndex = tableMeta.rowIndex;
          const resource = list[resourceIndex];
          return calculateAvailableDays(resource);
        },
      },
    },
    {
      label: "Carried Over Days",
      name: "id",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.Requests[0]?.carryoverDays,
      },
    },
    // {
    //   label: "Days available(this year)",
    //   name: "id",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRenderLite: (dataIndex, rowIndex) => {},
    //   },
    // },

    {
      label: "Days Taken",
      name: "id",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.Requests[0]?.leaveDays,
      },
    },
    {
      label: "Remaning Days",
      name: "remainingDays",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          // console.log("rowIndex", list[rowIndex]);
          const carriedOver = list[rowIndex]?.Requests[0]?.carryoverDays ?? 0;
          const daysAvailable = list[rowIndex]?.Requests[0]?.remainingDays ?? 0;
          const daysTaken = list[rowIndex]?.Requests[0]?.leaveDays ?? 0;
          return daysAvailable + carriedOver - daysTaken;
        },
      },
    },
    // {
    //   label: "Days Remaining",
    //   name: "remainingDays",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRenderLite: (dataIndex, rowIndex) => {
    //       const carriedOver = list[rowIndex]?.Requests[0]?.carryoverDays ?? 0;
    //       const daysAvailable = list[rowIndex]?.Requests[0]?.remainingDays ?? 0;
    //       const daysTaken = list[rowIndex]?.Requests[0]?.leaveDays ?? 0;
    //       return daysAvailable + carriedOver - daysTaken;
    //     },
    //   },
    // },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => <StatusLayout status={v} />,
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => (
          <div className="flex items-center">
            <IconButton
              onClick={(e) => {
                // Stop propagation to prevent row click handler
                e.stopPropagation();

                const selectedResource = list.find((x) => x.id === v);
                const selectedRequest = selectedResource?.Requests[0];

                if (selectedRequest) {
                  setFormData({
                    remainingDays: selectedRequest.remainingDays ?? 0,
                    carryoverDays: selectedRequest.carryoverDays ?? 0,
                  });
                  // Use the request ID (not the resource ID)
                  setRequestId(selectedRequest.id);
                  setFormOpen(true);
                }
              }}
            >
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Edit"
                className="mr-2 text-sm"
              />
            </IconButton>
          </div>
        ),
      },
    },
  ];

  useEffect(() => {
    SetSelectedMenu({
      menu: "annual",
      title: "Annual Leave",
    });
  }, []);

  // Function to handle successful form submission
  const handleFormSuccess = () => {
    setFormOpen(false);

    // Method 1: Force component re-render by updating the refreshKey
    setRefreshKey((prevKey) => prevKey + 1);

    // Method 2: Use tableRef to trigger datatable refresh
    if (tableRef.current && tableRef.current.refreshData) {
      tableRef.current.refreshData();
    }

    // Method 3: Find and click the datatable refresh button
    const refreshButton = document.querySelector(".MuiDataTable-refresh");
    if (refreshButton) {
      refreshButton.click();
    }
  };

  return (
    <div className="">
      <FormDialog
        open={formOpen}
        setOpen={setFormOpen}
        title="Edit Annual Leave Details"
        fields={fields}
        buttonTitle="Save"
        url={`/api/annual/update/${requestId}`}
        onSuccess={handleFormSuccess}
      />

      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogContent>
          <PermissionDetails requestId={info?.id} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Leave" {...a11yProps(0)} />
            <Tab label="Calendar" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel index={0} value={tabValue} p={0}>
          <DatatableComponent
            search={false}
            viewColumns={false}
            searchfield={true}
            key={refreshKey} // Add key to force re-render
            ref={tableRef} // Add ref to access component methods
            excel={true}
            title={
              <div className="flex items-center">
                <span className={"mr-2"}>
                  {/* <Typography variant={"h6"}>Annual Leave</Typography> */}
                  <Typography variant={"h6"}>Leave</Typography>
                </span>
                <span className={"flex-grow ms-2"}>
                  <input
                    type="number"
                    className="form-control px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow border focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={year}
                    onChange={(event) => setYear(Number(event.target.value))}
                    placeholder="year"
                  />
                </span>
              </div>
            }
            processData={(data) => {
              setList(data.data);
              return data;
            }}
            columns={columns}
            url={`/api/annual/list?year=${year}`}
            useMeetingUrl={true}
            onReport={(type) => {
              DownloadExcelFile(
                `/api/request/download/annual-leave?year=${year}`
              );
            }}
            onRowClick={(data, { rowIndex }) => {
              setInfo(list[rowIndex].Requests[0]);
              setOpen(true);
            }}
          />
        </TabPanel>
        <TabPanel index={1} value={tabValue} p={4}>
          <LeaveCalendar FetchDetails={FetchDetails} height={500} />
        </TabPanel>
      </Card>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualLeave);
